import React, {useEffect} from 'react';
import {classes, style} from './doppe-action-type-base-list-view-item.st.css';
import {
    ListViewItemRoot,
    listViewItemRootRenderRootElementAsButton,
    reactCreateMemo,
    useDynamicRef,
    useWasVisibleInViewport
} from '@wix/devzai-utils-react';
import {evaluateFunction, uiPartCreateMarking, Values} from '@wix/devzai-utils-common';
import {DoppeListActionSettings} from '../../../../client-server-common';
import {IDoppeViewerActionContext} from '../../../../doppe-sdk';
import {DoppeActionTypeListViewItemParts} from '../doppe-action-type-list-view-item.ui-parts';

export const DoppeActionTypeBaseListViewItemLayout = {
    Button: 'button',
    Div: 'div'
} as const;

export type DoppeActionTypeBaseListViewItemLayout = Values<typeof DoppeActionTypeBaseListViewItemLayout>;

export const DoppeActionTypeBaseListViewItem = reactCreateMemo(function DoppeActionTypeBaseListViewItem<PROPS extends DoppeListActionSettings.WithItemClickBehaviour>(
    props: {
        actionContext?: IDoppeViewerActionContext<PROPS>;
        innerItemIndex: number;
        innerItemId: string;
        contentClassName?: string;
        itemLayout: DoppeActionTypeBaseListViewItemLayout;
    } & React.HTMLAttributes<any>
) {
    const {
        actionContext,
        innerItemIndex,
        innerItemId,
        children,
        itemLayout,
        contentClassName,

        className,
        ...htmlAttributes
    } = props;


    const itemRootRef = useDynamicRef<HTMLDivElement>();
    const wasVisible = useWasVisibleInViewport(itemRootRef);

    useEffect(() => {
        if (wasVisible && actionContext) {
            actionContext.reportInnerItemViewed(innerItemId, innerItemIndex);
        }
    }, [wasVisible, actionContext, innerItemId, innerItemIndex]);

    const isButton = evaluateFunction(() => {
        switch (itemLayout) {
            case DoppeActionTypeBaseListViewItemLayout.Button: {
                return true;
            }
            case DoppeActionTypeBaseListViewItemLayout.Div: {
                return false;
            }
        }
    })

    // TODO: When testimonials list items are fixed, we can remove the logic `isButton ? undefined : CommonClasses.button`
    return (
        <ListViewItemRoot
            {...htmlAttributes}
            elementRef={itemRootRef}
            className={style(classes.root, {}, className)}
            {...uiPartCreateMarking(DoppeActionTypeListViewItemParts.ItemRoot, innerItemId)}
            renderRootElement={isButton ? listViewItemRootRenderRootElementAsButton : undefined}
        >
            <div
                className={style(classes.actionTypeListViewItemViewRootContent, {}, contentClassName)}
            >
                {children}
            </div>
        </ListViewItemRoot>
    );
});


